import React from 'react';
import Module from '../../../layout/Module';
import List from './List/List';
import AlertSaveButton from '../../../button/AlertSaveButton';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Upload from './Upload/Upload';

const PhotoManagement = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [view, setView] = React.useState('list');
  const permissions = useSelector((state) => state?.session?.permissions?.['photo-management'] || {});

  const onRedirect = (redirectTo) => {
    navigate(`/dashboard/photo-management${redirectTo}`);
  };

  return (
    <Module>
      <Module.Header title='Photo Management'>
        {pathname !== '/dashboard/photo-management/upload' && (

        <div className='flex justify-end items-center gap-2'>
          <AlertSaveButton
            submodule='Photo Management'
            icon='th-large'
            title='Grid'
            color='secondary'
            onDontSave={() => {
              onRedirect('');
              setView('grid');
            }}
          />
          <AlertSaveButton
            submodule='Photo Management'
            icon='th-list'
            title='List'
            color='secondary'
            onDontSave={() => {
              onRedirect('');
              setView('list');
            }}
          />
          {permissions?.upload && (
            <AlertSaveButton
              submodule='Photo Management'
              icon='upload'
              title='Upload'
              color='secondary'
              onDontSave={() => {
                onRedirect('/upload');
              }}
            />
          )}
        </div>
        )}

      </Module.Header>
      <Module.Body>
        <Routes>
          <Route index element={<List view={view} />} />
          <Route path='upload' element={<Upload />} />
        </Routes>
      </Module.Body>
    </Module>
  );
};

export default PhotoManagement;
